var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search_results_for_Profile_-_Flaticon-2",
    "data-name": "Search results for Profile - Flaticon-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.79,
    height: 25.461,
    viewBox: "0 0 22.79 25.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10369",
    "data-name": "Group 10369",
    transform: "translate(4.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10368",
    "data-name": "Group 10368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M117.4,0a6.611,6.611,0,1,0,6.611,6.611A6.628,6.628,0,0,0,117.4,0Z",
    transform: "translate(-110.791)",
    fill: "#121212"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10371",
    "data-name": "Group 10371",
    transform: "translate(0 13.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10370",
    "data-name": "Group 10370",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M46.906,252.65a6.162,6.162,0,0,0-.664-1.212,8.217,8.217,0,0,0-5.687-3.58,1.217,1.217,0,0,0-.837.2,7.046,7.046,0,0,1-8.314,0,1.083,1.083,0,0,0-.837-.2,8.157,8.157,0,0,0-5.687,3.58,7.1,7.1,0,0,0-.664,1.212.614.614,0,0,0,.029.548,11.517,11.517,0,0,0,.779,1.155,10.971,10.971,0,0,0,1.328,1.5,17.308,17.308,0,0,0,1.328,1.155,13.164,13.164,0,0,0,15.7,0,12.7,12.7,0,0,0,1.328-1.155,13.331,13.331,0,0,0,1.328-1.5,10.127,10.127,0,0,0,.779-1.155A.493.493,0,0,0,46.906,252.65Z",
    transform: "translate(-24.165 -247.841)",
    fill: "#121212"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMenuIcon);
export default __webpack_public_path__ + "static/media/profileMenuIcon.388ddbd05d09c87ccb42b37b73d458c5.svg";
export { ForwardRef as ReactComponent };